import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCoordinatorGroupMembers } from 'AppSrc/core/coordinators/coordinator-queries';
import { AlertPortal } from 'AppSrc/core/components/portals/alert-portal';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';
import 'AppSrc/core/style/components/view-crq-screen/change-assignee-modal.css';
import {
  updateEditCrqWithIdAssignToMe,
} from 'AppSrc/core/actions/actions-update-edit-form';
import { fetchCrqForViewEdit } from 'AppSrc/core/actions/actions-edit-form';
import { ES_VIEWING_NEW_SECTION } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';

const AssignToMeUnconnected = ({
  network,
  isChangeAnalyst,
  assignToMe,
  unAssign,
  statusReason,
  userLoggedIn, // info of the Logged In User
  changeAnalystCircuitCheckID, // info of the Circuit Check Analyst
  fetching,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openMemberDialog, setOpenMemberDialog] = useState(false);
  const [groupMembers, setGroupMembers] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [reAssigneId, setReAssigneId] = useState();
  const [showReAssignErr, setShowReAssignErr] = useState(false);
  // const [assignToID, setassignToID] = useState(changeAnalystCircuitCheckID);
  const [assingtext, getAssignTextDisplays] = useState();
  const [displayName, setDisplayName] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  useEffect(() => {
    // if (isChangeAnalyst === changeAnalystCircuitCheckID) {
    //   assingtext['I am working'];
    // }
    function setusername() {
      console.log('working');
      if (userLoggedIn === changeAnalystCircuitCheckID) {
        getAssignTextDisplays('Unassign');
      }
      else {
        getAssignTextDisplays('Assign To Me');
      }
    }
    setusername();
  }, [userLoggedIn, changeAnalystCircuitCheckID, getAssignTextDisplays, isChangeAnalyst]);

  useEffect(() => {
    setDisplayName(displayName);
  }, [displayName]);
  const searchHandler = (event) => {
    // Search function for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedName = groupMembers.filter((el) => {
      const searchValue = el.full_name.toLowerCase().includes(searchQuery);
      return searchValue;
    });

    setDisplayName(displayedName);
    setSearchInput(event);
  };

  const onClickassignToMe = () => {
    setOpenDialog(!openDialog);
  };
  const onClickYesAssign = () => {
    // assignToMe(network, setassignToID, changeAnalystCircuitCheckID);
    assignToMe(network);
    setOpenDialog(!openDialog);
    // getAssignTextDisplays('Unassign');
    // assignToMe(setAssign, assign, network);
  };

  const onClickYesUnAssign = () => {
    // unAssign(network, setassignToID, changeAnalystCircuitCheckID);
    unAssign(network);
    setOpenDialog(!openDialog);
    // getAssignTextDisplays('Assign To Me');
    // unAssign(setAssign, assign, network);
  };

  const OnClickNoAssign = () => {
    setOpenDialog(!openDialog);

  };

  const OnClickNoUnAssign = () => {
    setOpenDialog(!openDialog);
  };

  // Circuit checks Group member api call based on URl of pre-prod and prod
  const onClickReassign = () => {
    let groupid = '';
    if (window.location.origin === 'https://ace.internal.vodafone.com') {
      groupid = 'SGP000000008530';
    }
    else if (window.location.origin === 'https://ace-test.internal.vodafone.com') {
      groupid = 'SGP000000006227';
    }
    else {
      groupid = 'SGP000000008530';
    }
    getCoordinatorGroupMembers(network, groupid).then((results) => {
      // DISPATCH HERE FREYJA
      setGroupMembers([...results]);
      setDisplayName([...results]);
      console.log('group memeber assign state', displayName, isFetching);
      // setTableDisplay(buttonType);
      setIsFetching(false);
      // setIsApproverSignature(approvalrequestId);
    });
    setOpenMemberDialog(!openMemberDialog);
    setSearchInput('');
  };

  const onClickNoReassign = () => {
    setOpenMemberDialog(!openMemberDialog);
  };

  const onClickYesReassign = () => {
    if (reAssigneId) {
      assignToMe(network, reAssigneId);
      setOpenMemberDialog(!openMemberDialog);
    }
    else {
      setShowReAssignErr(false);
    }
  };

  const setReAssignEmailHandle = (param) => {
    setShowReAssignErr(true);
    setReAssigneId(param.email);
  };

  // Sort Circuit Check group in alphabetical order
  displayName.sort((a, b) => a.full_name.localeCompare(b.full_name));
  // const getAssignTextDisplay = () => {
  //   let assignValue = '';
  //   if (userLoggedIn !== changeAnalystCircuitCheckID) {
  //     assignValue = 'Assign to me';
  //   }
  //   else if (userLoggedIn === changeAnalystCircuitCheckID) {
  //     assignValue = 'Unassign';
  //   }
  //   else if (changeAnalystCircuitCheckID === null) {
  //     assignValue = 'Assign to me';
  //   }
  //   else if (changeAnalystCircuitCheckID === undefined) {
  //     assignValue = 'Assign to me';
  //   }
  //   return assignValue;
  // };

  // const getAssignText = getAssignTextDisplay();

  return (
    <div>
      {isChangeAnalyst === true && statusReason === '10500' && userLoggedIn
      && (
      <div className="assign-to-me-div">
        <button
          className="assign-to-me"
          type="button"
          onClick={onClickassignToMe}
        >
          {/* {((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'Assign to me' : 'Unassign' } */}
          {/* {(changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID)
          && 'Assign to me' }
          {((changeAnalystCircuitCheckID && userLoggedIn === changeAnalystCircuitCheckID))
          && 'Unassign' }
          {(changeAnalystCircuitCheckID === null)
          && 'Assign to me' }
          {(changeAnalystCircuitCheckID === undefined)
          && 'Assign to me' } */}
          {assingtext}
          {/* <br />
          {getAssignText} */}
        </button>
        {changeAnalystCircuitCheckID
        && (
        <div className="re-assign-cr ">
          <button className="btn-re-assign assign-to-me" type="button" onClick={onClickReassign}>Re-Assign</button>
        </div>
        )}
        <div className="assign-to-me-note">
          Note: The CRQ must be assigned to you before you can complete circuit checks.
          <br />
          {changeAnalystCircuitCheckID ? 'To assign to a colleague in the team to carry out circuit checks, please click on the re-assign button.' : ''}
        </div>
      </div>
      )}
      {openDialog
      && (
      <AlertPortal>
        <div className="alert-section">
          <div className="alert-shadow" />
          <div className="alert-inner">
            <div className="alert-texts">
              <h1 className="alert-title">
                {((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'Are you sure you want to assign this CRQ to yourself ?' : 'Are you sure you want to unassign this CRQ?'}
              </h1>
              <p className="alert-text">
                {((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'A CRQ must be assigned to you to enable you to complete circuit checks.' : 'The CRQ will need to be assigned to another Analyst and circuit checks will still need to be completed.'}
              </p>
            </div>
            <div className="alert-options alert-options-spacemaker" />
            <div className="alert-options">
              <div className="side-left">
                <OptionButton
                  className={((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'false-button-assign' : 'false-button-unassign'}
                  type="button"
                  onClick={((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? OnClickNoAssign : OnClickNoUnAssign}
                >
                  {((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'Back to work queue' : 'No, Keep Assigned To Me'}
                </OptionButton>
              </div>
              <div className="side-right">
                <OptionButton
                  className="true-button true-button-2"
                  type="button"
                  onClick={((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? onClickYesAssign : onClickYesUnAssign}
                >
                  {((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'Yes, Assign To Me' : 'Yes, Unassign'}
                </OptionButton>
              </div>
            </div>
          </div>
        </div>
      </AlertPortal>
      )}
      {openMemberDialog
        && (
        <ModalPortal>
          <div className="change-assignee-modal">
            <div className="change-assignee-shadow" />
            <div className="change-assignee-inner">
              <div className="ressign-table-outer select-assignee-section select-assignee-section-change-coordinator">
                <h4 className="section-title">Circuit Checks Group</h4>
                <div className="show-error-modal">{showReAssignErr}</div>
                <div className="select-coordinator-table vf-table">
                  <div className="vf-table-head-container">
                    <div className="vf-table-head">
                      <div className="head-item">
                        <span className="head-text">
                          Name
                        </span>
                      </div>
                      <div className="head-item">
                        <span className="head-text">
                          ID
                        </span>
                      </div>
                    </div>
                  </div>
                  <>
                    { // Search div when default array length > 2
                      groupMembers.length > 2 && (
                        <div className="search-drop">
                          <input
                            className="Search-Input"
                            type="text"
                            onChange={(e) => searchHandler(e.target.value)}
                            placeholder=" Please Search Here..."
                            value={searchInput}
                          />
                          <div className={`no-result-msg ${displayName.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
                        </div>
                      )
                    }
                  </>
                  <div className="vf-table-body">
                    {
                      displayName.map((member) => {
                        const isSelected = member.email === reAssigneId;
                        return (
                          <div
                            className={`vf-table-row-container${isSelected ? ' selected' : ''}`}
                            key={member.id}
                          >
                            <div className="vf-table-row">
                              <OptionButton
                                className="row-button"
                                onClick={setReAssignEmailHandle}
                                option={member}
                                disabled={isSelected}
                              >
                                <div className="row-item">
                                  <span className="row-item-text">
                                    {member.full_name}
                                  </span>
                                </div>
                                <div className="row-item">
                                  <span className="row-item-text">
                                    {member.id}
                                  </span>
                                </div>
                              </OptionButton>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
              <div className="form-modal-options form-modal-options-spacemaker" />
              <div className="form-modal-options">
                <div className="side-left">
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={onClickNoReassign}
                  >
                    Close
                  </button>
                </div>
                <div className="side-right">
                  <button
                    type="button"
                    className={`save-button save-button-${showReAssignErr ? 'ready' : 'not-ready'}`}
                    disabled={!showReAssignErr}
                    onClick={onClickYesReassign}
                  >
                    Re-Assign
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalPortal>
        )}
    </div>
  );
};

AssignToMeUnconnected.propTypes = {
  network: PropTypes.string,
  isChangeAnalyst: PropTypes.bool, // isChangeAnalyst PropTypes checking
  assignToMe: PropTypes.func,
  unAssign: PropTypes.func,
  userLoggedIn: PropTypes.string,
  statusReason: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  fetching: PropTypes.bool,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  assignToMe(network, reAssigneId) {
    const {
      crqId,
    } = ownProps;
    const isAssign = true;
    dispatch(updateEditCrqWithIdAssignToMe(crqId, isAssign, reAssigneId))
      .then(() => {
        dispatch(fetchCrqForViewEdit({
          editingStatus: ES_VIEWING_NEW_SECTION,
          crqId,
          network,
        }));
      });
  },


  unAssign(network) {
    const {
      crqId,
    } = ownProps;
    const isAssign = false;
    dispatch(updateEditCrqWithIdAssignToMe(crqId, isAssign))
      .then(() => {
        dispatch(fetchCrqForViewEdit({
          editingStatus: ES_VIEWING_NEW_SECTION,
          crqId,
          network,
        }));
      });
  },
});


const AssignToMeContent = connect(
  null,
  mapDispatchToProps,
)(AssignToMeUnconnected); // Wrapping method SectionSummaryHeaderConnect within Connect

export {
  AssignToMeContent,
};
